const MONTHS = [
  { g: { en: "January", ar: "يناير" }, h: { en: "Muharram", ar: "محرم" } },
  { g: { en: "February", ar: "فبراير" }, h: { en: "Safar", ar: "صفر" } },
  {
    g: { en: "March", ar: "مارس" },
    h: { en: "Rabie El Awal", ar: "ربيع الأول" }
  },
  {
    g: { en: "April", ar: "أبريل" },
    h: { en: "Rabie El Thany", ar: "ربيع الثاني" }
  },
  {
    g: { en: "May", ar: "مايو" },
    h: { en: "Jumada Al Aula", ar: "جمادى الأولى" }
  },
  {
    g: { en: "June", ar: "يونية" },
    h: { en: "Jumada Al Akhar", ar: "جمادى الآخر" }
  },
  { g: { en: "July", ar: "يوليو" }, h: { en: "Ragab", ar: "رجب" } },
  { g: { en: "August", ar: "أغسطس" }, h: { en: "Shaaban", ar: "شعبان" } },
  { g: { en: "September", ar: "سبتمبر" }, h: { en: "Ramadhan", ar: "رمضان" } },
  { g: { en: "October", ar: "أكتوبر" }, h: { en: "Shawwal", ar: "شوال" } },
  {
    g: { en: "November", ar: "نوفمبر" },
    h: { en: "Zul Qe'da", ar: "ذو القعدة" }
  },
  {
    g: { en: "December", ar: "ديسمبر" },
    h: { en: "Zul Hejjah", ar: "ذو الحجة" }
  }
];
const useBirthDate = () => {
  const getMonths = (type, lang) => MONTHS.map((month, i) => ({
    label: month[type][lang],
    value: i + 1
  }));
  const getYears = (type, minAge, maxAge) => {
    const offset = type === "h" ? 578 : 0;
    const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
    return Array.from({ length: maxAge - minAge + 1 }, (_, i) => {
      const year = currentYear - minAge - i;
      return { label: `${year - offset}`, value: year - offset };
    });
  };
  const getDays = (month, year) => Array.from({ length: new Date(year, month, 0).getDate() }, (_, i) => ({
    label: `${i + 1}`,
    value: i + 1
  }));
  return { getMonths, getYears, getDays };
};
export {
  useBirthDate
};
